window.AwesomeScrollbar = (function () {
    var generateDom = function (addClass, guid) {
        return [
            '<div class="awesome-scrollbar ' +
                addClass +
                '" id="awesome-scrollbar-' +
                guid +
                '">',
            '<div class="awesome-scrollbar__track" id="awesome-scrollbar__track-' +
                guid +
                '">',
            '<div class="awesome-scrollbar__thumb" id="awesome-scrollbar__thumb-' +
                guid +
                '"></div>',
            '</div>',
            '</div>',
        ].join('\n');
    };

    var AwesomeScrollbar = function (container, addClass) {
        addClass = addClass ? ' ' + addClass : '';

        this.container = $(container);
        this.guid = app.generateGUID();

        if (this.container.length < 1) return null;

        this.prevPageY = 0;

        this.container.wrap(
            '<div class="awesome-scrollbar__area-wrapper' +
                addClass +
                '"><div class="awesome-scrollbar__content-wrapper" id="' +
                addClass.trim() +
                '-scrollarea"><div class="awesome-scrollbar__content"></div></div></div>'
        );

        this.innerContainer = this.container.parent();
        this.outerContainer = this.innerContainer.parent();

        this.outerContainer.append(generateDom(addClass, this.guid));

        this.scrollbar = $('#awesome-scrollbar-' + this.guid);
        this.scrollbarTrack = $('#awesome-scrollbar__track-' + this.guid);
        this.scrollbarThumb = $('#awesome-scrollbar__thumb-' + this.guid);

        var self = this;

        this.innerContainer.resize(function () {
            self.update();
        });

        var resizeTimer = null;
        this.outerContainer.parent().resize(function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                self.update();
            }, 250);
        });

        this.update();
    };

    AwesomeScrollbar.prototype.getScrollProgress = function () {
        if (!this.outerContainer || !this.innerContainer) {
            return;
        }

        var innerContainerHeight = $(this.innerContainer).height();
        var outerContainerHeight = $(this.outerContainer).height();
        var diffHeight = innerContainerHeight - outerContainerHeight;
        var scrollTop = $(this.outerContainer).scrollTop();

        return ((scrollTop / diffHeight) * 100).toFixed(0);
    };

    AwesomeScrollbar.prototype.update = function () {
        if (!this.outerContainer) {
            return;
        }

        var outerContainerHeight = this.outerContainer.first().height(),
            innerContainerHeight = this.innerContainer.first().height();

        this.unbindEvents();

        if (innerContainerHeight > outerContainerHeight) {
            this.scrollbarTrack.removeClass('disabled');

            var thumbHeight =
                (outerContainerHeight * 100) / innerContainerHeight;

            var thumbHeightAbs = Math.round(
                (outerContainerHeight * thumbHeight) / 100
            );
            //thumbHeightAbs = thumbHeightAbs < 40 ? 40 : thumbHeightAbs;

            this.scrollbarThumb.css({
                height: thumbHeightAbs,
            });

            this.bindEvents();
        } else {
            this.scrollbarTrack.addClass('disabled');
        }
    };

    AwesomeScrollbar.prototype.bindEvents = function () {
        var self = this;

        this.outerContainer.first().on('scroll.table', function (e) {
            self.scrollHandler($(this).scrollTop());

            document.dispatchEvent(
                new CustomEvent('awesomeScrollbarScroll', {
                    detail: {
                        progress: self.getScrollProgress(),
                        element: self.container[0],
                    },
                })
            );
        });

        this.scrollbarThumb
            .on('mousedown', function (e) {
                self.startDrag(e);
                self.prevPageY =
                    e.currentTarget.offsetHeight -
                    (e.clientY - e.currentTarget.getBoundingClientRect().top);
            })
            .on('click', function (e) {
                e.stopImmediatePropagation();
            });

        this.scrollbarTrack
            .on('wheel', function (e) {
                self.scrollArea(e);
                e.preventDefault();
            })
            .on('click', function (e) {
                self.clickTrack(e);
            });

        document.dispatchEvent(
            new CustomEvent('awesomeScrollbarScroll', {
                detail: {
                    progress: this.getScrollProgress(),
                    element: this.container[0],
                },
            })
        );

        return this;
    };

    AwesomeScrollbar.prototype.unbindEvents = function () {
        this.outerContainer.first().off('scroll.table');
        this.scrollbarThumb.off('mousedown');
        this.scrollbarTrack
            .off('wheel')
            .off('mouseenter')
            .off('mouseleave')
            .off('click')
            .off('mousemove');

        return this;
    };

    AwesomeScrollbar.prototype.destroy = function () {
        if (this.outerContainer) {
            this.unbindEvents();

            this.container.insertBefore(this.outerContainer.parent());
            this.outerContainer.parent().remove();
            this.outerContainer = null;
        }
    };

    AwesomeScrollbar.prototype.scrollArea = function (e) {
        var scrollTop;
        var currentScrollTop = this.outerContainer.first().scrollTop();

        if (e.originalEvent.deltaY > 0) {
            scrollTop = currentScrollTop + 60;
        } else {
            scrollTop = currentScrollTop - 60;
        }

        this.outerContainer.scrollTop(scrollTop);
    };

    AwesomeScrollbar.prototype.clickTrack = function (e) {
        var offset = Math.abs(e.target.getBoundingClientRect().top - e.clientY),
            thumbHalf = this.scrollbarThumb.get(0).offsetHeight / 2,
            thumbPositionPercentage =
                ((offset - thumbHalf) * 100) /
                this.scrollbarTrack.get(0).offsetHeight;

        var scrollTop =
            (thumbPositionPercentage *
                this.outerContainer.get(0).scrollHeight) /
            100;
        this.outerContainer.scrollTop(scrollTop);
    };

    AwesomeScrollbar.prototype.scrollHandler = function (scrollTop) {
        var y = (scrollTop / this.outerContainer.get(0).scrollHeight) * 100;

        this.scrollbarThumb.css({
            top: y + '%',
        });
    };

    AwesomeScrollbar.prototype.clickThumbHandler = function (e) {
        e.stopImmediatePropagation();
        this.startDrag(e);
        this.prevPageY =
            e.currentTarget.offsetHeight -
            (e.clientY - e.currentTarget.getBoundingClientRect().top);
    };

    AwesomeScrollbar.prototype.startDrag = function (e) {
        var self = this;
        e.stopImmediatePropagation();
        $('body').addClass('vertical-scroll-disable');
        self.scrollbarThumb.addClass('is-moving');
        self.scrollbar.addClass('is-moving');

        function moveAt(e) {
            const offset =
                    (self.scrollbarTrack.get(0).getBoundingClientRect().top -
                        e.clientY) *
                    -1,
                thumbClickPosition =
                    self.scrollbarThumb.get(0).offsetHeight - self.prevPageY,
                thumbPositionPercentage =
                    ((offset - thumbClickPosition) * 100) /
                    self.scrollbarTrack.get(0).offsetHeight;

            const scrollTop =
                (thumbPositionPercentage *
                    self.outerContainer.get(0).scrollHeight) /
                100;

            self.outerContainer.scrollTop(scrollTop);
        }

        $(document).on('mousemove', function (e) {
            moveAt(e);
        });

        $(document).on('mouseup', function (e) {
            $(document).off('mousemove');
            $(document).off('mouseup');
            $('body').removeClass('vertical-scroll-disable');
            self.scrollbarThumb.removeClass('is-moving');
            self.scrollbar.removeClass('is-moving');
            self.prevPageY = 0;

            e.stopImmediatePropagation();
        });
    };

    return AwesomeScrollbar;
})();
